import { status } from '../../config.ts'
import { drawPrizesPage1 } from './data.ts'
import { wait } from '@/__mocks__/util/async.ts'

export default [
  {
    method: 'GET',
    path: '/campaign-draw-prizes?drawId=1&limit=20',
    reply: async () => {
      await wait()
      return [status.ok, drawPrizesPage1]
    }
  },
  {
    method: 'POST',
    path: '/campaign-draw-prizes',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'PUT',
    path: '/campaign-draw-prizes/1',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'DELETE',
    path: '/campaign-draw-prizes/1',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  }
]
